import aetna from '@/images/insuranceLogos/color/aetna.svg'
import ambetter from '@/images/insuranceLogos/color/ambetter.svg'
import bluecrossBlueshield from '@/images/insuranceLogos/color/bluecross-blueshield.svg'
import cigna from '@/images/insuranceLogos/color/cigna.svg'
import healthnet from '@/images/insuranceLogos/color/healthnet.svg'
import humana from '@/images/insuranceLogos/color/humana.svg'
import kaiserPermanente from '@/images/insuranceLogos/color/kaiser-permanente.svg'
import molinaHealthcare from '@/images/insuranceLogos/color/molina-healthcare.svg'
import medicaid from '@/images/insuranceLogos/color/medicaid.svg'
import medicare from '@/images/insuranceLogos/color/medicare.svg'
import optum from '@/images/insuranceLogos/color/optum.svg'
import oscar from '@/images/insuranceLogos/color/oscar.svg'
import tricare from '@/images/insuranceLogos/color/tricare.svg'
import unitedHealthcare from '@/images/insuranceLogos/color/united-healthcare.svg'
import anthem from '@/images/insuranceLogos/color/anthem.svg'
import triwest from '@/images/insuranceLogos/color/triwest.svg'

export const insuranceLogosColor = {
  aetna,
  ambetter,
  anthem,
  cigna,
  'bluecross-blueshield': bluecrossBlueshield,
  healthnet,
  humana,
  'kaiser-permanente': kaiserPermanente,
  'molina-healthcare': molinaHealthcare,
  medicaid,
  medicare,
  optum,
  oscar,
  tricare,
  triwest,
  'united-healthcare': unitedHealthcare
}
